"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[4165],{

/***/ 4165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Slider)
});

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(9755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./node_modules/@accessible360/accessible-slick/slick/slick.js
var slick = __webpack_require__(7475);
;// CONCATENATED MODULE: ./node_modules/@on-sight/dev-tools/src/utils/sync-elements-height.js
/**
 * Updates a list of elements to all match the height of the tallest element provided
 *
 * @param {jQuery node list} $elements
 */
function syncElementsHeight($elements) {
  if (!$elements.length) return

  // Reset heights to get accurate measurement
  $elements.height('auto')

  // Sort elements by intrinsic height
  const sortedByHeight = $elements.sort((a, b) => {
    return b.offsetHeight - a.offsetHeight
  })
  const maxHeight = sortedByHeight[0].offsetHeight

  // Set all elements to match the tallest element found
  $elements.height(maxHeight)
}
// EXTERNAL MODULE: ./node_modules/@on-sight/dev-tools/src/utils/elements-exist.js
var elements_exist = __webpack_require__(4635);
;// CONCATENATED MODULE: ./dev/assets/js/components/slick-slider.js




/**
 * * Initializes any Slick sliders using the provided config
 * 
 * @options
		* [data-slick] {required} - Optionally pass a Slick config
		* [data-sync-heights] - Sync slide heights to match tallest slide
		* [data-destroy-responsive] - Destroys / Doesn't initialize the slider when the responsive settings don't display enough slides
 */
function Slider({ wrapper }) {
	const $slider = jquery_default()(wrapper);

	jquery_default()(document).on('slick-slider:reinit', function () {
		$slider.slick('setPosition');
	})

		; (function init() {
			const config = getConfig($slider);

			$slider.slick(config);

			$slider.find('.slick-slide').on('click', (e) => onSlideClick(e));

			if ($slider.filter('[data-sync-heights]').length) {
				jquery_default()(window).on('resize', () => {
					$slider.slick('setPosition');
				});

				$slider.on('setPosition', () => {
					const $slides = $slider.find('.slick-slide');
					syncElementsHeight($slides);
				});

				// $slider.slick('setPosition');
				$slider.slick('slickGoTo', 0);
			}

			if (!$slider.hasClass('slick-initialized') || $slider.filter('[data-remove-attrs]').length) {
				$slider.removeAttr('role')
				$slider.removeAttr('aria-label')
			}

			checkForCounter();
		})()

	function checkForCounter() {
		const $section = $slider.closest('.shopify-section');
		const $counter = $section.find('[data-hook="slick-counter"]');

		if (!(0,elements_exist/* default */.Z)([$section, $counter])) return;

		$slider.on('beforeChange', function (_, __, ___, slideIndex) {
			$counter.text(slideIndex + 1);
		});
	}

	/**
	 * 
	 * @param {*} $slider 
	 * @returns 
	 * 
	 * @example
			if ( classList.includes('js-your-custom-class') ) {
					config = {};
			}
	 */
	function getConfig($slider) {
		const classNames = $slider.attr('class');
		const classList = classNames?.split(' ');
		let config = null;

		// * Add custom configuration objects here
		// ...

		return config;
	}

	function onSlideClick(event) {
		const $slide = jquery_default()(event.currentTarget);
		const slickIndex = $slide.data('slick-index');
		const $slider = $slide.closest('[data-slick]');

		$slider.slick('slickGoTo', slickIndex);
	}
}


/***/ })

}]);